var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityTypeHeader } from './entity-type-header';
import { useEntity } from '../hooks/use-entity';
import { OutlineEntityBubble, OutlineEntityBubbleDefaultProps } from './outline-entity-bubble';
var cls = classNames('entity-main-header');
export var EntityMainHeaderDefaultProps = {
  outlineBubble: OutlineEntityBubbleDefaultProps
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 0.8em;\n  "], ["\n    font-size: 0.8em;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 0.9em;\n  "], ["\n    font-size: 0.9em;\n  "]))),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n  "], ["\n    display: flex;\n    gap: ", ";\n  "])), theme.UNIT(4))
});
var OutlineBubbleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TypeAndNameStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";   \n    margin-top: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";   \n    margin-top: ", ";\n  "])), theme.UNIT(1), theme.UNIT(2))
});
var TypeStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    line-height: 1.1em;\n    margin: 0;\n    font-size: ", "em;\n    font-weight: 500;\n  "], ["\n    line-height: 1.1em;\n    margin: 0;\n    font-size: ", "em;\n    font-weight: 500;\n  "])), 30 / 16)
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  TypeAndName: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TypeAndNameStyles),
  Type: styled(EntityTypeHeader)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TypeStyles),
  Name: styled.h1(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  OutlineBubble: styled(OutlineEntityBubble)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), OutlineBubbleStyles),
  Controls: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
export var EntityMainHeader = function (props) {
  var className = props.className,
    children = props.children,
    outlineBubble = props.outlineBubble;
  var entity = useEntity(props.entity);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.OutlineBubble, __assign({}, outlineBubble, {
    entity: entity
  })), React.createElement(My.TypeAndName, null, React.createElement(My.Type, {
    entity: entity
  }), React.createElement(My.Name, null, entity.name))), children);
};
EntityMainHeader.defaultProps = EntityMainHeaderDefaultProps;
EntityMainHeader.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;